// extracted by mini-css-extract-plugin
export default {"wrapper":"bX-z","availablePromoMessagesLabel":"cX-z","promoMessageList":"dX-z","promoMessage":"eX-z","appliedPromoMessage":"fX-z","promoMessageAmount":"gX-z"};